export enum FollowUpStudyLoadState {
	Loading = "loading",
	Ready = "ready",
	Error = "error",
}
